<div class="container">
  <div class="row d-flex justify-content-between align-items-baseline align-content-center">
    <app-pagetitle
      [title]="title"></app-pagetitle>
    <mat-form-field>
      <mat-label>Select a date range</mat-label>
      <mat-date-range-input [formGroup]="riskAnalysisDateRange" [rangePicker]="picker">
        <input matStartDate formControlName="start" placeholder="Start date" (focus)="picker.open()" readonly>
        <input matEndDate formControlName="end" placeholder="End date" (focus)="picker.open()" readonly
               (ngModelChange)="onDateRangeChange()">

      </mat-date-range-input>
      <button *ngIf="riskAnalysisDateRange&&riskAnalysisDateRange.value.start" matSuffix mat-icon-button
              aria-label="Clear" matTooltip="Clear date" (click)="onClearDateRangeClick()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

      <mat-error *ngIf="riskAnalysisDateRange.controls.start.hasError('matStartDateInvalid')">Invalid start
        date
      </mat-error>
      <mat-error *ngIf="riskAnalysisDateRange.controls.end.hasError('matEndDateInvalid')">Invalid end
        date
      </mat-error>
    </mat-form-field>
  </div>
  <!--  <div class="row">-->
  <!--    <div class="col-sm-4 col-md-3">-->
  <!--      <app-stat title="Total Trips" class="pointer"-->
  <!--                [value]="riskAnalysisResponse?riskAnalysisResponse.totalTrips:'-'"-->
  <!--                icon="car-colored-icon"></app-stat>-->
  <!--    </div>-->
  <!--    <div class="col-sm-4 col-md-3">-->
  <!--      <app-stat [title]="'Total Safe Trips'" class="pointer"-->
  <!--                [value]="riskAnalysisResponse?riskAnalysisResponse.totalSafeTrips:'-'"-->
  <!--                icon="car-shield-icon"></app-stat>-->
  <!--    </div>-->
  <!--    <div class="col-sm-4 col-md-3">-->
  <!--      <app-stat [title]="'Total Distance Driven'" class="pointer"-->
  <!--                [value]="riskAnalysisResponse?riskAnalysisResponse.totalDistanceDriven:'-'"-->
  <!--                icon="car-colored-icon"></app-stat>-->
  <!--    </div>-->
  <!--    <div class="col-sm-4 col-md-3">-->
  <!--      <app-stat [title]="'Total Safe KMs'" class="pointer"-->
  <!--                [value]="riskAnalysisResponse?riskAnalysisResponse.totalSafeKm:'-'"-->
  <!--                icon="car-success-icon"></app-stat>-->
  <!--    </div>-->
  <!--    <div class="col-sm-4 col-md-3">-->
  <!--      <app-stat [title]="'Alerts Count'" class="pointer"-->
  <!--                [value]="riskAnalysisResponse?riskAnalysisResponse.drivingAlertsCount:'-'"-->
  <!--                icon="car-warning-icon"></app-stat>-->
  <!--    </div>-->
  <!--  </div>-->

  <div class="row d-flex align-content-stretch flex-wrap">
    <div class="col-md-8 pr-0 pl-md-4">
      <div class="card col-12  h-100">
        <div class="card-body pl-0 pr-0" >
          <h4 class="card-title  text-center">Improvement Plan</h4>

<!--          <apx-chart dir="ltr" class="apex-charts h-auto" [series]="alertsAnalysisData.series"-->
<!--                     [chart]="alertsAnalysisData.chart"-->
<!--                     [legend]="alertsAnalysisData.legend" [colors]="alertsAnalysisData.colors"-->
<!--                     [labels]="alertsAnalysisData.labels"-->
<!--                     [dataLabels]="alertsAnalysisData.dataLabels" [plotOptions]="alertsAnalysisData.plotOptions">-->
<!--          </apx-chart>-->
<!--          <div class="chartjs-chart">-->
<!--            &lt;!&ndash; Bar Chart &ndash;&gt;-->
<!--            <canvas baseChart *ngIf="alertsAnalysisData" [datasets]="alertsAnalysisData.datasets" chartType="bar" [options]="alertsAnalysisData.options"-->
<!--                    height="300" [labels]="alertsAnalysisData.labels">-->
<!--            </canvas>-->
<!--          </div>-->

          <apx-chart
            [series]="chartOptions.series"
            [chart]="chartOptions.chart"
            [yaxis]="chartOptions.yaxis"
            [xaxis]="chartOptions.xaxis"
            [labels]="chartOptions.labels"
            [stroke]="chartOptions.stroke"
            [title]="chartOptions.title"
            [dataLabels]="chartOptions.dataLabels"
            [fill]="chartOptions.fill"
            [plotOptions]="chartOptions.plotOptions"
            [tooltip]="chartOptions.tooltip"
          ></apx-chart>
        </div>
      </div>
    </div>
  </div>

</div>
